var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from '@mui/material';
import FacilityDetailHeader from 'common/FacilityDetailHeader/FacilityDetailHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAppDispatch } from 'hooks/reduxHooks';
import { showFacilityBreadcrumb } from 'pages/WCPages/Admin/CorporateAndFacilities/FacilityManagement/FacilityManagement.action';
import AlertsDashboard from 'pages/WCPages/Home/components/AlertsDashboard';
var FacilityCareDashboard = function (props) {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var location = useLocation();
    var handleCareClick = function () {
        var basePath = location.pathname.replace(/\/facilityCare$/, "");
        navigate(basePath);
    };
    useEffect(function () {
        dispatch(showFacilityBreadcrumb());
        dispatch(showFacilityBreadcrumb());
    }, []);
    return (_jsxs(Box, { className: 'facility-card', children: [_jsx(Box, { children: _jsx(FacilityDetailHeader, {}) }), _jsx(Box, { display: "flex", justifyContent: "flex-end", mb: 2, children: _jsx(Button, { color: "primary", variant: "contained", style: { borderRadius: 0, fontSize: "16px", textTransform: 'none' }, onClick: function () { return handleCareClick(); }, children: "Home View" }) }), _jsx(AlertsDashboard, __assign({}, props))] }));
};
export default FacilityCareDashboard;
